import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Pupil } from 'src/modules/enaio-certificates/shared/pupil.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { Certificate } from '../../shared/certificate.entity';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Wrapper } from 'src/modules/utils/misc/wrapper.model';
import { Progressor } from 'src/modules/utils/misc/Progressor';
import { CertificateStatus } from '../../shared/certificate.status.enum';
import { EnaioCertificatesTools } from '../../shared/enaio-certificates-tools';
import { SchoolClass } from '../../shared/school-class.model';

@Component({
    selector: 'enaio-certificates-pupil-list',
    templateUrl: './pupil-list.component.html',
    styleUrls: ['./pupil-list.component.scss']
})
export class PupilListComponent extends ComponentView {

    _Utils = Utils;

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { schoolClassId: "number", isHalfYear: "bool" };
    schoolClassId: number;
    isHalfYear: boolean;

    isAdmin = false;
    pupils: Pupil[] = [];
    certificates: Certificate[] = [];
    schoolClass: SchoolClass;

    progressor = new Wrapper<Progressor>();

    async initParams(): Promise<boolean> {
        [this.pupils, this.certificates, this.schoolClass] = await Promise.all([
            this.service.restGetPupils(this.schoolClassId),
            RestEndpoint.main().find({ schoolClassId: this.schoolClassId, onlyStatus: true }).run("api/cer/certificate").list(Certificate),
            this.service.restGetSchoolClass(this.schoolClassId)
        ]);
        
        for (let certificate of this.certificates) {
            let found = this.pupils.find(p => p.id === certificate.pupilId);
            if (found != null) {
                found.certificateStatus = certificate.status;
            }
        }
        this.isAdmin = this.service.isAdminForCertificates();
        this.app.updateNavigation(null, [
            this.service.getHomeCertificates(),
            { label: "Klasse " + this.schoolClass.getDisplayName(), routerLink: ["/enaio-certificates", "pupils", this.schoolClassId, this.isHalfYear ? 1 : 0] }
        ]);
        return true;
    }

    async selectRow(event): Promise<void> {
        await this.app.navigateTo(["/enaio-certificates", "certificate", this.schoolClassId, this.isHalfYear ? 1 : 0, event.data.id]);
    }

    async refresh(): Promise<void> {
        this.app.showSpinner = true;
        let changes = await RestEndpoint.main().query({id: this.schoolClassId, isHalfYear: this.isHalfYear, previewOnly: true}).run("api/cer/certificate/refreshForSchoolClass").listStrings();
        if (changes.length === 0) {
            this.app.showSpinner = false;
            await this.app.messageDialog.info("Es wurden keine Änderungen in den zugrundeliegenden Kompetenzen festgestellt. Die Zeugnisse bleiben unverändert");
        }
        else {
            this.app.showSpinner = false;
            if (await this.app.messageDialog.yesNo("Folgende Änderungen werden vorgenommen. Fortfahren?<br><br>" + Utils.arrayItemsToString(changes, "<br>"), "Bestätigung")) {
                this.app.showSpinner = true;
                await RestEndpoint.main().query({id: this.schoolClassId, isHalfYear: this.isHalfYear, previewOnly: false}).run("api/cer/certificate/refreshForSchoolClass").listStrings();
                this.app.showSpinner = false;
            }
        }

        this.app.showSpinner = false;
    }

    async saveAllDocuments(): Promise<void> {
        let pupils = this.pupils.filter(pupil => pupil.certificateStatus != CertificateStatus.none);
        if (pupils.length == 0) {
            await this.app.messageDialog.info("Es gibt in dieser Klasse noch keinen Schüler mit angefangener Zeugnisbearbeitung. Daher werden keine Zeugnisse generiert");
            return;
        }    

        if (await this.app.messageDialog.yesNo("Sollen alle Zeugnisse dieser Klasse als Dokument in enaio abgelegt werden (Das betrifft " + pupils.length + " Zeugnis" + (pupils.length > 1 ? "se" : "") + ")?", "Bestätigung")) {
            this.progressor.value = new Progressor();
            this.progressor.value.max = pupils.length;
            try {
                
                for (let pupil of this.pupils) {
                    if (pupil.certificateStatus != CertificateStatus.none) {
                        let cert = this.certificates.find(c => c.pupilId == pupil.id);
                        if (cert == null) {
                            continue;
                        }
                        this.progressor.value.value++;
                        this.progressor.value.text = "Generiere Zeugnis für " + pupil.getFullName();
                        await RestEndpoint.main().query({ id: cert.id, forHalfYear: EnaioCertificatesTools.getCertificateIsForHalfYear(new Date()) }).run("api/cer/certificate/savedocument").getText();            
                    }
                }
            }
            finally {
                this.progressor.value = null;
            }
        }
    }


}
